import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../redux/instance/api";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Fetch counselors list for member dashboard
 */
export const getCounselorList = createAsyncThunk(
  "member/getCounselorList",
  async ({ limit = 10, offset = 0 } = {}, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/counsellor/search?offset=${offset}&limit=${limit}&orderBy=id&direction=DESC`,
        {}
      );

      const status = "success";
      const data = {
        status: status,
        message: response.data,
      };
      return data;
    } catch (error) {
      const status = "error";
      const data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return rejectWithValue(data);
    }
  }
);

const counselorListSlice = createSlice({
  name: "counselorList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCounselorList: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCounselorList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCounselorList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCounselorList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export const { clearCounselorList } = counselorListSlice.actions;
export default counselorListSlice.reducer;
